import { h } from '@stencil/core';
import cn from 'classnames';
import smoothscroll from 'smoothscroll-polyfill';
import { pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
smoothscroll.polyfill();
const SCREENS_NUMBER_THRESHOLD = 4;
export class BackToTop {
  constructor() {
    this.handleClick = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
    this.isShown = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  onWindowScroll() {
    const { innerHeight, scrollY } = window || {};
    const scrolledScreens = Math.floor(scrollY / innerHeight) + 1;
    if (scrolledScreens >= SCREENS_NUMBER_THRESHOLD) {
      this.isShown = true;
    }
    else {
      this.isShown = false;
    }
  }
  render() {
    return (h("button", { onClick: this.handleClick, class: cn('back-to-top', this.isShown ? 'back-to-top--shown' : 'back-to-top--hidden') }, h("div", { class: "back-to-top__wrapper" }, h("pes-icon", { size: pesIconSizes.SMALL, mirror: pesIconMirrorDirection.VERTICAL }, "arrow2_down"))));
  }
  static get is() { return "pes-back-to-top"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["back-to-top.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["back-to-top.css"]
    };
  }
  static get states() {
    return {
      "isShown": {}
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "scroll",
        "method": "onWindowScroll",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
